export default __webpack_public_path__ + "static/media/Lightbulb_2.d44c69cf.svg";